module.exports = __webpack_public_path__ + "assets/ParallelogramBySP.f8af059f8e4f131a1253b8813faf8b9e.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/ParallelogramBySP.gmt
// module id = 980
// module chunks = 0